<div class="resume-group">
  <div class="layers">
    @for (item of group.items; track item.position; let index = $index) {
      <ng-fence-preview-element [item]="item" (isLoaded)="onLoaded($event, index)"></ng-fence-preview-element>
    }
  </div>

  <!-- Affichage pour une quantité -->
  @if (group.quantity) {
    <h5 class="text-center mt-2">
      X {{ group.quantity }}{{ group.type === FencePreviewItemTypeEnum.BoardCut && !configuration.isVertical ? ' à couper' : '' }}
    </h5>
  }

  <!-- Affichage pour un message -->
  @if (group.messages?.length > 0) {
    <div class="messages">
      @for (message of group.messages; track message) {
        <h5 class="text-center mt-2">{{ message }}</h5>
      }
    </div>
  }
</div>
